import { GetSetting } from '@/api/basis';

const state = {
  sidebarFoldState: false, //菜单栏折叠状态 false展开 true折叠
  pageHeaderAppendText: '', //页头
  systemSetData: {} //系统设置信息
};

const mutations = {
  // 改变菜单栏折叠状态
  changeSidebarFoldState(state) {
    state.sidebarFoldState = !state.sidebarFoldState;
  },
  // 设置页头尾部文字
  setPageHeaderAppendText(state, value) {
    state.pageHeaderAppendText = value;
  },
  // 重置数据
  resetState(state) {
    state.sidebarFoldState = false;
    state.pageHeaderAppendText = '';
  },
  // 系统设置信息
  changeSystemConfigData(state, value) {
    document.title = value.individuation.web_title || '百舸云';
    let linkEl = document.querySelector("link[rel*='icon']");
    linkEl.href = value.individuation.web_logo;

    state.systemSetData = value;
  }
};

const actions = {
  // 获取平台配置信息
  getSystemSetInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      GetSetting({
        key: ''
      }).then(res => {
        commit('changeSystemConfigData', res.data.list);
        resolve();
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
